module.exports = __webpack_public_path__ + "media/images/flags/RE-de996e5b842d77d9f673863ef2e71425.svg";